import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const linkClass = ({ isActive }: { isActive: boolean }) =>
  `px-3 py-2 rounded-md flex items-center gap-2 ${isActive ? 'bg-gray-800 text-green-300' : 'hover:bg-gray-800'}`;

const AppShell: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-950 to-black text-white">
      {/* Header */}
      <header className="w-full bg-gradient-to-r from-gray-900/80 via-gray-900/60 to-gray-900/80 backdrop-blur border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <i className="fas fa-seedling text-green-400"></i>
            <span className="font-semibold tracking-wide">AuraFarm</span>
          </Link>
          {/* Main nav, only when authenticated */}
          {user ? (
            <nav className="hidden md:flex items-center gap-2 text-sm">
              <NavLink to="/" className={linkClass}>
                <i className="fas fa-home"></i><span>Dashboard</span>
              </NavLink>
              <NavLink to="/plots" className={linkClass}>
                <i className="fas fa-tractor"></i><span>Plots</span>
              </NavLink>
              <NavLink to="/market" className={linkClass}>
                <i className="fas fa-store"></i><span>Market</span>
              </NavLink>
              <NavLink to="/leaderboards" className={linkClass}>
                <i className="fas fa-trophy"></i><span>Leaderboards</span>
              </NavLink>
              <NavLink to="/quests" className={linkClass}>
                <i className="fas fa-scroll"></i><span>Quests</span>
              </NavLink>
              <div className="ml-2 flex items-center gap-2">
                <span className="px-2 py-1 rounded bg-yellow-600/20 border border-yellow-600/30 text-yellow-300 flex items-center gap-1">
                  <i className="fas fa-coins"></i>
                  <span>${Number(user.balance ?? 0).toFixed(2)}</span>
                </span>
                <span className="opacity-80 text-sm">{user.username}</span>
                <button className="px-3 py-1 rounded bg-red-600 hover:bg-red-500" onClick={logout}>Logout</button>
              </div>
            </nav>
          ) : (
            <nav className="flex items-center gap-2 text-sm">
              <NavLink to="/login" className={linkClass}>
                <i className="fas fa-sign-in-alt"></i><span>Login</span>
              </NavLink>
              <NavLink to="/register" className={linkClass}>
                <i className="fas fa-user-plus"></i><span>Register</span>
              </NavLink>
            </nav>
          )}
        </div>
      </header>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 py-6">
        {children}
      </div>

      {/* Mobile bottom nav when authenticated */}
      {user && (
        <nav className="fixed bottom-0 left-0 right-0 md:hidden bg-gray-900/90 backdrop-blur border-t border-gray-800">
          <div className="max-w-7xl mx-auto px-4 py-2 grid grid-cols-5 gap-2 text-xs">
            <NavLink to="/" className={linkClass}><i className="fas fa-home"></i><span>Home</span></NavLink>
            <NavLink to="/plots" className={linkClass}><i className="fas fa-tractor"></i><span>Plots</span></NavLink>
            <NavLink to="/market" className={linkClass}><i className="fas fa-store"></i><span>Market</span></NavLink>
            <NavLink to="/leaderboards" className={linkClass}><i className="fas fa-trophy"></i><span>Ranks</span></NavLink>
            <NavLink to="/quests" className={linkClass}><i className="fas fa-scroll"></i><span>Quests</span></NavLink>
          </div>
        </nav>
      )}
    </div>
  );
};

export default AppShell;